import HomePageV2 from '@/app/modules/HomePageV2';
import CMSContainer from '@/modules/CMSContainer';
import { faqSeoSchemaData } from '@/modules/HomePageV2/staticData/faqData';
import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { useAnalytics } from '@/utils/useAnalytics';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { FAQPageJsonLd, NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { getDynamicPageData } from 'utils/getDynamicPageData';

const HomePage = ({ pageData }: DynamicPageData) => {
  const defaultTitle = 'Search over 2,000 Doctor Jobs in Australia and New Zealand.';
  const defaultDescription = 'Discover the right doctor job for you in Australia or New Zealand';
  const track = useAnalytics();

  useEffect(() => {
    track('Page View', {
      'Page Title': 'Homepage',
      'Live experiments': [],
    });
  }, [track]);

  return (
    <CMSContainer shouldUpdateFooterStyles>
      <NextSeo
        canonical={pageData.canonical_url}
        title={pageData.meta_title ?? defaultTitle}
        description={pageData.meta_description ?? defaultDescription}
        noindex={!pageData.index}
        nofollow={!pageData.index}
        openGraph={{
          title: pageData.meta_title ?? defaultTitle,
          description: pageData.meta_description ?? defaultDescription,
        }}
      />
      <FAQPageJsonLd mainEntity={faqSeoSchemaData} />
      <HomePageV2 />
    </CMSContainer>
  );
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<DynamicPageData>> {
  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.Home_Page, context, undefined);

  if (error) {
    return { notFound: true };
  }

  if (pageData?.redirect_url) {
    return {
      redirect: {
        destination: pageData.redirect_url,
        permanent: true,
      },
    };
  }

  return {
    props: {
      data: modules,
      pageData,
    },
  };
}

export default HomePage;
